<template>
  <div class="mobileOrder botPage">
    <mbHeader :title="$t('myOrders')" :left="true" :lang="true"></mbHeader>
    <order></order>
    <recommended :padding="true"></recommended>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import order from '../Profile/order';
import recommended from "../recommended";

export default {
  name: "mobileorder",
  components: {order, mbHeader,recommended}
}
</script>

<style scoped lang="less">
.mobileOrder{
  min-height: 100vh;
  padding: 50px 0 16px;
  background-color: rgba(0, 0, 0, 0.02);
  display: flex;
  flex-flow: column;
  overflow: hidden;

}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileOrder.vue